import React, { useState, useEffect, useRef } from "react";
import { Link, Element } from "react-scroll";
import axios from "axios";
import "./Products.css";
import "./Button.css";
import { IoSearchSharp } from "react-icons/io5";

const Produtos = () => {
  const [produtos, setProdutos] = useState([]);
  const [addProduct, setAddProduct] = useState(false);
  const [categories, setCategories] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const menuNavRef = useRef(null);
  const [newProduct, setNewProduct] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    file: null,
  });

  const getToken = () => {
    return localStorage.getItem("token");
  };
  const clearSearch = () => {
    setSearchQuery("");
  };

  const fetchProdutos = async () => {
    try {
      const token = getToken();
      const response = await axios.get("https://cardapio.olympicbarbacena.com.br/api/produtos", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProdutos(response.data);
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      handleNetworkError(error);
    }
  };

  useEffect(() => {
    const fetchProdutos = async () => {
      try {
        const token = getToken();
        const response = await axios.get("https://cardapio.olympicbarbacena.com.br/api/produtos", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProdutos(response.data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
        handleNetworkError(error);
      }
    };

    const fetchCategories = async () => {
      try {
        const token = getToken();
        const response = await axios.get("https://cardapio.olympicbarbacena.com.br/api/categories", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCategories(response.data);
      } catch (error) {
        console.error("Erro ao buscar categorias:", error);
        handleNetworkError(error);
      }
    };

    fetchProdutos();
    fetchCategories();
  }, []);

  const handleNetworkError = (error) => {
    if (error.response && error.response.status === 403) {
      alert("Sessão expirada. Por favor, faça login novamente.");
      localStorage.removeItem("token");
      window.location.href = "/login";
    } else {
      alert(`Erro de conexão. Verifique sua internet e tente novamente. ${error.response.status}`);
    }
  };

  const handleSave = async (produto) => {
    try {
      const token = getToken();
      const formData = new FormData();
      formData.append("name", produto.name);
      formData.append("description", produto.description);
      formData.append("price", produto.price);
      formData.append("category", produto.category);
      if (produto.file) {
        formData.append("image", produto.file);
      }
      const response = await axios.put(
        `https://cardapio.olympicbarbacena.com.br/api/produtos/${produto._id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setProdutos((prev) =>
        prev.map((p) => (p._id === produto._id ? { ...produto, image: response.data.image } : p))
      );
      setEditingProductId(null);
    } catch (error) {
      console.error("Erro ao salvar produto:", error);
      handleNetworkError(error);
    }
  };

  const handleCreate = async () => {
    try {
      const token = getToken();
      const formData = new FormData();
      formData.append("name", newProduct.name);
      formData.append("description", newProduct.description);
      formData.append("price", newProduct.price);
      formData.append("category", newProduct.category);
      if (newProduct.file) {
        formData.append("image", newProduct.file);
      }
      const response = await axios.post(
        "https://cardapio.olympicbarbacena.com.br/api/produtos",
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setProdutos((prev) => [...prev, response.data]);
      setNewProduct({ name: "", description: "", price: "", category: "", file: null });
      setAddProduct(false)
    } catch (error) {
      console.error("Erro ao criar produto:", error);
      handleNetworkError(error);
    }
  };

  const toggleStockStatus = async (produto) => {
    try {
      const token = getToken();
      const updatedProduct = { ...produto, inStock: !produto.inStock };
      await axios.put(`https://cardapio.olympicbarbacena.com.br/api/produtos/${produto._id}`, updatedProduct, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProdutos((prev) =>
        prev.map((p) => (p._id === produto._id ? updatedProduct : p))
      );
    } catch (error) {
      console.error("Erro ao atualizar status de estoque:", error);
      handleNetworkError(error);
    }
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Tem certeza de que deseja excluir este produto?");
    if (!confirmed) return;

    try {
      const token = getToken();
      await axios.delete(`https://cardapio.olympicbarbacena.com.br/api/produtos/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProdutos((prev) => prev.filter((p) => p._id !== id));
    } catch (error) {
      console.error("Erro ao excluir produto:", error);
      handleNetworkError(error);
    }
  };
  const filteredProdutos = produtos.filter((produto) =>
    produto.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    produto.category.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleSetActive = (categoryName) => {
    
    const menuNav = menuNavRef.current;
    if (menuNav) {
      const activeLink = menuNav.querySelector(`[data-category="${categoryName}"]`);
      
      if (activeLink) {
        const offsetLeft = activeLink.offsetLeft;
        const offsetWidth = activeLink.offsetWidth;
        const containerWidth = menuNav.offsetWidth;
  
        // Ajustar deslocamento horizontal para centralizar o item ativo
        menuNav.scrollTo({
          left: offsetLeft - containerWidth / 2 + offsetWidth / 2,
          behavior: "smooth", // Animação suave
        });
      }
    }
  };
  const filteredMenuData = produtos.filter(
    (item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      categories.find(
        (category) =>
          category.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
          category.name === item.category
      )
  );

  const filteredCategories = categories.filter(
    (category) =>
      category.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      filteredMenuData.some((item) => item.category === category.name)
  );

  return (
    <div className="crud-menu-container">
      
      {/* Formulário para criar novo produto */}
      <div>
        
        {addProduct &&(
        <div className="crud-menu-item ">
          <h2>Criar Novo Produto</h2>
          <div className="crud-menu-item-edit">
            <input
              type="text"
              placeholder="Nome"
              value={newProduct.name}
              onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })}
              className="crud-edit-input create-product-input"
            />
          </div>
          <div className="crud-menu-item-edit">
            <textarea
              placeholder="Descrição"
              value={newProduct.description}
              onChange={(e) => setNewProduct({ ...newProduct, description: e.target.value })}
              className="crud-edit-textarea create-product-input"
            />
          </div>
          <div className="crud-menu-item-edit">
            <input
              type="number"
              placeholder="Preço"
              value={newProduct.price}
              onChange={(e) => setNewProduct({ ...newProduct, price: e.target.value })}
              className="crud-edit-input create-product-input"
            />
          </div>
          <div className="crud-menu-item-edit">
            <select
              value={newProduct.category}
              onChange={(e) => setNewProduct({ ...newProduct, category: e.target.value })}
              className="crud-edit-input create-product-input"
            >
              <option value="">Selecione uma categoria</option>
              {categories.map((category) => (
                <option key={category._id} value={category.name}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>
          <div className="crud-menu-item-edit">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setNewProduct({ ...newProduct, file: e.target.files[0] })}
              className="crud-edit-input create-product-input"
            />
          </div>
          <div className="crud-menu-item-edit">
            <button onClick={handleCreate} className="crud-save-button save-product-button">
              Criar Produto
            </button>
            <button
              onClick={() => setAddProduct(false)}
              className="crud-cancel-button"
            >
              Cancelar
            </button>
          </div>
        </div>
        )}

      </div>

      <nav className="crud-menu-nav" ref={menuNavRef}>
        {filteredCategories.map((category) => (
          <Link
            key={category._id}
            to={category.name}
            spy={true}
            smooth={true}
            duration={500}
            offset={-50}
            className="crud-menu-nav-link"
            data-category={category.name}
            onSetActive={() => handleSetActive(category.name)}
          >
            {category.name}
          </Link>
        ))}
      </nav>
        {/* Barra de Pesquisa */}
      
      <div className="menu-search">
        <IoSearchSharp className="busca" />
        <input
          type="text"
          placeholder="Buscar produto"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="menu-search-input"
        />
        {searchQuery && (
          <button onClick={clearSearch} className="menu-search-clear">
            ✖
          </button>
        )}
      </div>
      {!addProduct &&(
          <button className="custom-button" onClick={() => setAddProduct(true)}>
            Adicionar produto
          </button>

      )}
      {categories
      .filter((category) =>
        filteredProdutos.some((produto) => produto.category === category.name)
      )
      .map((category) => (
        <Element key={category._id} name={category.name} className="crud-menu-section">
          <h3 className="crud-menu-category-title">{category.name}</h3>
          {filteredProdutos
            .filter((produto) => produto.category === category.name)
            .map((produto) => (
              <div
                key={produto._id}
                className={`crud-menu-item ${!produto.inStock ? "crud-out-of-stock" : ""}`}
              >
                {editingProductId === produto._id ? (
                  <div className="crud-menu-item-edit">
                    <input
                      type="text"
                      value={produto.name}
                      onChange={(e) =>
                        setProdutos((prev) =>
                          prev.map((p) =>
                            p._id === produto._id ? { ...p, name: e.target.value } : p
                          )
                        )
                      }
                      className="crud-edit-input"
                    />
                    <textarea
                      value={produto.description}
                      onChange={(e) =>
                        setProdutos((prev) =>
                          prev.map((p) =>
                            p._id === produto._id
                              ? { ...p, description: e.target.value }
                              : p
                          )
                        )
                      }
                      className="crud-edit-textarea edit-area"
                      // class='crud-edit-textarea edit-area'
                    />
                    <input
                      type="number"
                      value={produto.price}
                      onChange={(e) =>
                        setProdutos((prev) =>
                          prev.map((p) =>
                            p._id === produto._id
                              ? { ...p, price: parseFloat(e.target.value) }
                              : p
                          )
                        )
                      }
                      className="crud-edit-input"
                    />
                    <select
                      value={produto.category}
                      onChange={(e) =>
                        setProdutos((prev) =>
                          prev.map((p) =>
                            p._id === produto._id
                              ? { ...p, category: e.target.value }
                              : p
                          )
                        )
                      }
                      className="crud-edit-input"
                    >
                      <option value="">Selecione uma categoria</option>
                      {categories.map((category) => (
                        <option key={category._id} value={category.name}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onload = () => {
                            setProdutos((prev) =>
                              prev.map((p) =>
                                p._id === produto._id
                                  ? { ...p, tempImage: reader.result, file }
                                  : p
                              )
                            );
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                      className="crud-edit-input"
                    />
                    {produto.tempImage && (
                      <img
                        src={produto.tempImage}
                        alt="Pré-visualização"
                        className="crud-image-preview"
                      />
                    )}
                    {produto.image && (
                      <img
                        src={`https://cardapio.olympicbarbacena.com.br${produto.image}`}
                        alt="Pré-visualização"
                        className="crud-image-preview"
                      />
                    )}
                    
                    <div className="crud-menu-item-actions">
                      <button
                        onClick={() => handleDelete(produto._id)}
                        className="crud-delete-button"
                      >
                        Excluir
                      </button>
                      <button
                        onClick={() => {
                          setEditingProductId(null)
                          fetchProdutos()
                        }}
                        className="crud-cancel-button"
                      >
                        Cancelar
                      </button>
                      <button onClick={() => handleSave(produto)} className="crud-save-button">
                        Salvar
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="crud-menu-item-info">
                      <div className="crud-menu-item-header">
                        <h3>{produto.name}</h3>
                        {produto.image && (
                          <img
                            src={`https://cardapio.olympicbarbacena.com.br${produto.image}`}
                            alt={produto.name}
                            className="crud-image-right"
                          />
                        )}
                      </div>
                      <p>{produto.description}</p>
                      <p>R$ {produto.price}</p>
                      <p>Status: {produto.inStock ? "Em Estoque" : "Fora de Estoque"}</p>
                    </div>
                    <div className="crud-menu-item-actions">
                      <button
                        onClick={() => setEditingProductId(produto._id)}
                        className="crud-edit-button"
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => toggleStockStatus(produto)}
                        className="crud-stock-button"
                      >
                        {produto.inStock ? "Fora de Estoque" : "Em Estoque"}
                      </button>
                      
                    </div>
                  </>
                )}
              </div>
            ))}
        </Element>
        
      ))}
    {/* Produtos sem categoria */}
    {filteredProdutos
      .filter((produto) => !categories.some((category) => category.name === produto.category))
      .length > 0 && (
      <Element name="sem-categoria" className="crud-menu-section">
        <h3 className="crud-menu-category-title">Produtos Sem Categoria</h3>
        {filteredProdutos
          .filter((produto) => !categories.some((category) => category.name === produto.category))
          .map((produto) => (
            <div
              key={produto._id}
              className={`crud-menu-item ${!produto.inStock ? "crud-out-of-stock" : ""}`}
            >
              {editingProductId === produto._id ? (
                <div className="crud-menu-item-edit">
                  <input
                    type="text"
                    value={produto.name}
                    onChange={(e) =>
                      setProdutos((prev) =>
                        prev.map((p) =>
                          p._id === produto._id ? { ...p, name: e.target.value } : p
                        )
                      )
                    }
                    className="crud-edit-input"
                  />
                  <textarea
                    value={produto.description}
                    onChange={(e) =>
                      setProdutos((prev) =>
                        prev.map((p) =>
                          p._id === produto._id
                            ? { ...p, description: e.target.value }
                            : p
                        )
                      )
                    }
                    className="crud-edit-textarea edit-area"
                  />
                  <input
                    type="number"
                    value={produto.price}
                    onChange={(e) =>
                      setProdutos((prev) =>
                        prev.map((p) =>
                          p._id === produto._id
                            ? { ...p, price: parseFloat(e.target.value) }
                            : p
                        )
                      )
                    }
                    className="crud-edit-input"
                  />
                  <select
                    value={produto.category || ""}
                    onChange={(e) =>
                      setProdutos((prev) =>
                        prev.map((p) =>
                          p._id === produto._id
                            ? { ...p, category: e.target.value }
                            : p
                        )
                      )
                    }
                    className="crud-edit-input"
                  >
                    <option value="">Selecione uma categoria</option>
                    {categories.map((category) => (
                      <option key={category._id} value={category.name}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = () => {
                          setProdutos((prev) =>
                            prev.map((p) =>
                              p._id === produto._id
                                ? { ...p, tempImage: reader.result, file }
                                : p
                            )
                          );
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                    className="crud-edit-input"
                  />
                  {produto.tempImage && (
                    <img
                      src={produto.tempImage}
                      alt="Pré-visualização"
                      className="crud-image-preview"
                    />
                  )}
                  {produto.image && (
                    <img
                      src={`https://cardapio.olympicbarbacena.com.br${produto.image}`}
                      alt="Pré-visualização"
                      className="crud-image-preview"
                    />
                  )}
                  <div className="crud-menu-item-actions">
                    <button
                      onClick={() => handleDelete(produto._id)}
                      className="crud-delete-button"
                    >
                      Excluir
                    </button>
                    <button
                      onClick={() => {
                        setEditingProductId(null);
                        fetchProdutos();
                      }}
                      className="crud-cancel-button"
                    >
                      Cancelar
                    </button>
                    <button onClick={() => handleSave(produto)} className="crud-save-button">
                      Salvar
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="crud-menu-item-info">
                    <h3>{produto.name}</h3>
                    <p>{produto.description}</p>
                    <p>R$ {produto.price}</p>
                    <p>Status: {produto.inStock ? "Em Estoque" : "Fora de Estoque"}</p>
                  </div>
                  <div className="crud-menu-item-actions">
                    <button
                      onClick={() => setEditingProductId(produto._id)}
                      className="crud-edit-button"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => toggleStockStatus(produto)}
                      className="crud-stock-button"
                    >
                      {produto.inStock ? "Fora de Estoque" : "Em Estoque"}
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
      </Element>
    )}
    </div>
  );
};

export default Produtos;
